var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.803 3.333C10.803 1.493 12.302 0 14.15 0A3.34 3.34 0 0 1 17.5 3.333c0 1.841-1.5 3.334-3.349 3.334-.934 0-1.777-.381-2.384-.994L7.13 8.83a3.33 3.33 0 0 1-.182 1.916l5.083 3.34a3.35 3.35 0 0 1 2.12-.753 3.34 3.34 0 0 1 3.348 3.334C17.5 18.507 16 20 14.15 20a3.34 3.34 0 0 1-3.348-3.333c0-.483.103-.942.288-1.356L6.05 12a3.35 3.35 0 0 1-2.202.821A3.34 3.34 0 0 1 .5 9.487a3.34 3.34 0 0 1 3.348-3.333c1.064 0 2.01.493 2.623 1.261l4.493-3.059a3.3 3.3 0 0 1-.161-1.023",
    clipRule: "evenodd"
  })));
};
export default SvgShare;